const searchButtons = document.querySelectorAll(".search-button");
const body = document.body;

searchButtons.forEach((searchButton) => {
    const container = searchButton.parentElement;
    const searchBar = container.querySelector(".search-bar");
    const searchIcon = searchButton.querySelector(".search-icon");
    const closeIcon = searchButton.querySelector(".close-icon");
    const searchLabel = searchButton.querySelector(".search-label");
    const searchInput = searchBar.querySelector("#searchInput");

    // Observer para enfocar cuando se abre
    const observer = new MutationObserver(() => {
        if (!searchBar.classList.contains('hidden') && searchInput) {
            searchInput.focus();
        }
    });

    observer.observe(searchBar, { attributes: true, attributeFilter: ['class'] });

    // Click en el botón
    searchButton.addEventListener("click", () => {
        const isOpen = searchBar.classList.toggle("hidden");

        searchIcon?.classList.toggle("hidden", !isOpen);
        closeIcon?.classList.toggle("hidden", isOpen);
        searchLabel.textContent = isOpen ? "Open search bar" : "Close search bar";
        searchButton.setAttribute("aria-expanded", String(!isOpen));

        if (isOpen && searchInput) {
            setTimeout(() => {
                if (!searchBar.classList.contains("hidden")) {
                    searchInput.focus();
                }
            }, 300);
        }
    });

    // Cierre al hacer click fuera
    body.addEventListener("click", function (event) {
        if (
            !searchBar.contains(event.target) &&
            !searchButton.contains(event.target)
        ) {
            if (!searchBar.classList.contains('hidden')) {
                searchBar.classList.add('hidden');
                searchIcon?.classList.remove("hidden");
                closeIcon?.classList.add("hidden");
                searchLabel.textContent = "Open search bar";
                searchButton.setAttribute("aria-expanded", "false");
            }
        }
    });
});
